<template>
  <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition" width="500">
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Category</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="save">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-layout>
          <v-flex xs12>
            <el-form :label-position="`top`" label-width="100px" size="mini">
              <el-form-item label="Shop ID">
                <el-input v-model="product.shop_id" readonly></el-input>
              </el-form-item>
              <el-form-item label="Name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="Ranking">
                <el-input type="tel" v-model="form.rank"></el-input>
              </el-form-item>
            </el-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../../services";

export default {
  name: "create-category",
  props: {
    dialog: { default: false },
    product: { default: null }
  },
  data() {
    return {
      form: {
        name: "",
        rank: 0
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      let data = {
        ...this.form,
        shop_id: this.product.shop_id
      };
      Service.Shop.addCategory(data).then(res => {
        console.log(res);
        if (res.success) {
          this.$emit("save");
        }
      });
    }
  }
};
</script>